export const initialState = {
    wallet: null,
    walletProvider: null,
    walletAddress: '',
    connected: false
};